export default "__VITE_ASSET__BdE_Boke__"